<template>
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M13.4133 4.47333L11.5267 2.58667C11.152 2.21149 10.6436 2.00047 10.1133 2H5.88667C5.35641 2.00047 4.84805 2.21149 4.47333 2.58667L2.58667 4.47333C2.21149 4.84805 2.00047 5.35641 2 5.88667V12C2 12.5304 2.21071 13.0391 2.58579 13.4142C2.96086 13.7893 3.46957 14 4 14H12C12.5304 14 13.0391 13.7893 13.4142 13.4142C13.7893 13.0391 14 12.5304 14 12V5.88667C13.9995 5.35641 13.7885 4.84805 13.4133 4.47333ZM5.41333 3.52667C5.54109 3.40484 5.71016 3.33579 5.88667 3.33333H10.1133C10.2898 3.33579 10.4589 3.40484 10.5867 3.52667L11.7267 4.66667H4.27333L5.41333 3.52667ZM12 12.6667H4C3.82319 12.6667 3.65362 12.5964 3.5286 12.4714C3.40357 12.3464 3.33333 12.1768 3.33333 12V6H12.6667V12C12.6667 12.1768 12.5964 12.3464 12.4714 12.4714C12.3464 12.5964 12.1768 12.6667 12 12.6667Z"
			fill="white"
		/>
		<path
			d="M9.99998 7.33333C9.82317 7.33333 9.6536 7.40357 9.52858 7.52859C9.40355 7.65362 9.33331 7.82319 9.33331 8C9.33331 8.35362 9.19284 8.69276 8.94279 8.94281C8.69274 9.19286 8.3536 9.33333 7.99998 9.33333C7.64636 9.33333 7.30722 9.19286 7.05717 8.94281C6.80712 8.69276 6.66665 8.35362 6.66665 8C6.66665 7.82319 6.59641 7.65362 6.47138 7.52859C6.34636 7.40357 6.17679 7.33333 5.99998 7.33333C5.82317 7.33333 5.6536 7.40357 5.52858 7.52859C5.40355 7.65362 5.33331 7.82319 5.33331 8C5.33331 8.70724 5.61426 9.38552 6.11436 9.88562C6.61446 10.3857 7.29274 10.6667 7.99998 10.6667C8.70722 10.6667 9.3855 10.3857 9.8856 9.88562C10.3857 9.38552 10.6666 8.70724 10.6666 8C10.6666 7.82319 10.5964 7.65362 10.4714 7.52859C10.3464 7.40357 10.1768 7.33333 9.99998 7.33333Z"
			fill="white"
		/>
	</svg>
</template>
<script>
export default {
	name: 'IconShop',
}
</script>
